export class MailHistoryAttachmentOutDTO {
  filename!: string;
  cid?: string;
}
